import React, { useContext, useEffect, useState } from 'react';
import MainLayout from '@55degrees/layout-r18';
import { reportMixPanel } from '@55degrees/consent-tracker';
import { A3DocumentContext } from '../contexts/A3DocumentContext';
import { APP_HEADER_HEIGHT } from '../config';

export default function ActionableAgile({
  appFooterHeight,
  dateFormat,
  isDarkMode,
  locale,
  weekStartsOn,
  notifyFiltering,
  resetFiltersScope,
}) {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);
  const { a3Document, activeChart } = useContext(A3DocumentContext);

  const updateDimensions = () => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  let a3Height = height;

  if (APP_HEADER_HEIGHT) a3Height -= APP_HEADER_HEIGHT;
  if (appFooterHeight) a3Height -= appFooterHeight;

  const inlineStyle = {
    marginTop: '1rem',
    maxHeight: height,
    height,
    maxWidth: width,
    width,
    position: 'fixed',
    boxSizing: 'revert',
  };

  if (isDarkMode) {
    inlineStyle.backgroundColor = '#000';
  }
  return (
    <div style={inlineStyle}>
      <MainLayout
        locale={locale}
        isDarkMode={isDarkMode}
        document={a3Document}
        chart={activeChart}
        date_format={dateFormat}
        weekStartsOn={weekStartsOn}
        height={a3Height}
        appHeaderHeight={APP_HEADER_HEIGHT}
        appFooterHeight={appFooterHeight}
        notifyFiltering={notifyFiltering}
        resetFiltersScope={resetFiltersScope}
        appKey="azure-cloud"
        mixPanelReportEvent={reportMixPanel}
        chartHeaderSupportLinks={{
          aging_wip: 'https://support.55degrees.se/space/AA4A/2454290684',
          cycle_time_histogram: 'https://support.55degrees.se/space/AA4A/2328690689',
          cycle_time_scatter_plot: 'https://support.55degrees.se/space/AA4A/2454028332',
          cumulative_flow_diagram: 'https://support.55degrees.se/space/AA4A/2544271361',
          dashboard: 'https://support.55degrees.se/space/AA4A/2387902696',
          flow_efficiency: 'https://support.55degrees.se/space/AA4A/2350350337',
          heat_map: 'https://support.55degrees.se/space/AA4A/2319679637',
          monte_carlo_how_many: 'https://support.55degrees.se/space/AA4A/2407694337',
          monte_carlo_when: 'https://support.55degrees.se/space/AA4A/2407694552',
          process_behavior_chart: 'https://support.55degrees.se/space/AA4A/2316402691',
          source_data: 'https://support.55degrees.se/space/AA4A/2319679491',
          throughput_histogram: 'https://support.55degrees.se/space/AA4A/2328691075',
          throughput_run_chart: 'https://support.55degrees.se/space/AA4A/2319613980',
          wip_run_chart: 'https://support.55degrees.se/space/AA4A/2320105474',
          work_item_age_run_chart: 'https://support.55degrees.se/space/AA4A/3859382278',
        }}
      />
    </div>
  );
}
